import React from 'react';
export function ComparisonSection() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3410">
      <div className="bg-[#1874cd] py-4 px-6" data-id="element-3411">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-3412">
          Plasma Cutting Machine VS Fiber Laser Cutting Machine
        </h2>
      </div>

      <div className="p-8 space-y-12" data-id="element-3413">
        {/* Fiber Laser Adv/Disadv */}
        <div data-id="element-3414">
          <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3415">
            Advantages And Disadvantages of Fiber Laser Cutting
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-3416">
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-3417">
              <h4 className="text-xl font-bold text-green-600 mb-4 flex items-center" data-id="element-3418">
                <span className="mr-2" data-id="element-3419">+</span> Advantages:
              </h4>
              <p className="text-gray-700 mb-4" data-id="element-3420">
                Fiber laser cutting offers several advantages over plasma
                cutting in various applications. Here are some benefits of fiber
                laser cutting compared to plasma cutting:
              </p>
              <ul className="space-y-4 text-gray-700" data-id="element-3421">
                <li data-id="element-3422">
                  <strong data-id="element-3423">Higher Precision:</strong> Fiber laser cutting
                  provides superior precision and accuracy compared to plasma
                  cutting. The focused laser beam of a fiber laser allows for
                  narrow kerf widths and fine detail cutting, resulting in
                  cleaner and more precise cuts. Plasma cutting, on the other
                  hand, can produce wider kerf widths and may have limitations
                  in achieving intricate cuts.
                </li>
                <li data-id="element-3424">
                  <strong data-id="element-3425">Smaller Heat-Affected Zone (HAZ):</strong> Fiber laser
                  cutting generates a smaller heat-affected zone, which refers
                  to the area around the cut that experiences thermal
                  alteration. This minimal HAZ reduces the risk of warping,
                  distortion, and material damage, especially in heat-sensitive
                  materials. Plasma cutting can produce a larger HAZ, which may
                  affect the structural integrity of the material.
                </li>
                <li data-id="element-3426">
                  <strong data-id="element-3427">Faster Cutting Speeds:</strong> Fiber laser cutting is
                  generally faster than plasma cutting. Fiber lasers can achieve
                  higher cutting speeds, enabling increased productivity and
                  reduced manufacturing lead times. Plasma cutting, although
                  efficient for thicker materials, may be relatively slower for
                  thinner materials.
                </li>
                <li data-id="element-3428">
                  <strong data-id="element-3429">Versatility with Material Thickness:</strong> Fiber
                  lasers are suitable for cutting a wide range of material
                  thicknesses, from thin gauge to thick plates. They provide
                  consistent cutting performance across different material
                  thicknesses. Plasma cutting is generally more effective for
                  thicker materials, while it may struggle with precision cuts
                  on thin materials.
                </li>
                <li data-id="element-3430">
                  <strong data-id="element-3431">Cleaner Cutting Process:</strong> Fiber laser cutting
                  produces clean and precise cuts with minimal dross or slag
                  formation. This reduces the need for secondary operations,
                  such as grinding or deburring. Plasma cutting, especially at
                  higher power levels, can generate more dross and require
                  additional post-cutting finishing processes.
                </li>
                <li data-id="element-3432">
                  <strong data-id="element-3433">Reduced Operating Costs:</strong> Fiber laser cutting
                  typically has lower operating costs compared to plasma
                  cutting. Fiber lasers consume less energy and require less
                  maintenance and consumables, such as gas and electrodes,
                  resulting in reduced operational expenses.
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-3434">
              <h4 className="text-xl font-bold text-red-600 mb-4 flex items-center" data-id="element-3435">
                <span className="mr-2" data-id="element-3436">-</span> Disadvantages:
              </h4>
              <ul className="space-y-4 text-gray-700" data-id="element-3437">
                <li data-id="element-3438">
                  <strong data-id="element-3439">High cost:</strong> Initial investment require high
                  costs.
                </li>
                <li data-id="element-3440">
                  <strong data-id="element-3441">Low efficiency:</strong> At present, fiber laser
                  cutting of thin plates (≤25mm) is more cost-effective.
                  However, when cutting thick plates, the efficiency is low, so
                  unless the quality requirements are high, it is not suitable
                  for fiber laser cutting.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="border-gray-200" data-id="element-3442" />

        {/* Plasma Adv/Disadv */}
        <div data-id="element-3443">
          <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3444">
            Advantages And Disadvantages Of Plasma Cutting
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-3445">
            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-3446">
              <h4 className="text-xl font-bold text-green-600 mb-4 flex items-center" data-id="element-3447">
                <span className="mr-2" data-id="element-3448">+</span> Advantages:
              </h4>
              <ul className="space-y-4 text-gray-700" data-id="element-3449">
                <li data-id="element-3450">
                  In the process of cutting medium and thick plates(≥25mm), it
                  can reach a very high cutting speed, much higher than laser
                  cutting and flame cutting.
                </li>
                <li data-id="element-3451">
                  The initial equipment investment is lower than the laser.
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200" data-id="element-3452">
              <h4 className="text-xl font-bold text-red-600 mb-4 flex items-center" data-id="element-3453">
                <span className="mr-2" data-id="element-3454">-</span> Disadvantages:
              </h4>
              <ul className="space-y-4 text-gray-700" data-id="element-3455">
                <li data-id="element-3456">
                  The verticality of the cutting surface is poor: the side of
                  the cutting surface will have a large inclined cutting edge,
                  and the verticality will be very poor.
                </li>
                <li data-id="element-3457">
                  Produce more cutting slag: Cutting slag will be generated at
                  the bottom of the cutting surface during the cutting process.
                  In order not to affect the quality of post-processing, this
                  slag must be removed by grinding, which also increases labor
                  costs.
                </li>
                <li data-id="element-3458">
                  Generate harmful gas and arc light: The principle of plasma
                  cutting determines that harmful dust and arc light will be
                  generated during the cutting process. However, underwater
                  plasma cutting is also used to avoid this defect.
                </li>
                <li data-id="element-3459">
                  High cost in the later stage: More cutting nozzles are
                  consumed in the later stage, and the cost is very high.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}